module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAPFBMVEUAAACrq4Cmh2Cnh2CmhmCqi2Cmhl+miGCtimamh1+mh2CmiF+nh2CoiGKlh1+mhmCniV+niGBnZGClhl+SnYXNAAAAEnRSTlMABbJ/1xf5TRCpn4p1PcG4Y1qilgsYAAAAkklEQVRIx+3WMQ6DMBQEURMgMQESYO9/V8otBmzcGYmt50murB+2wtUKwsU94F5gbtci0Er6AqR7qQdI94p54J5PyvavBiDXA+R7gqn7zYkeYJH0/pz2BINkwZ5glCzYE8ROFuwJQm+B/hBYoD8GFoP7FLBAT0DBnsCCPYEFewII9AReHP9TU/m/9IAiUPPpULIdEZc+pyV1BlQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fl20210204/choose_agree_yes.png
// module id = 8Mly
// module chunks = 0